import API from '../..';

export const getIntercomJwt = () => API.get('/api/v1/intercom/token/');
